module.exports = __webpack_public_path__ + "img/settings.19a990c4.svg";